import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Modal from '@jobcase/react_pattern_library/components/Modal';
import get from 'lodash/get';

// the && is needed to make sure that the Modal styles are overwritten.
const ModalStyled = styled(Modal)`
  && {
    margin-bottom: ${({ theme }) => get(theme, 'spacing.default')}px;
    padding: 0;
    top: 120px;
    width: 620px;

    ${({ isMobile, backgroundColor, theme }) => (isMobile && `
      background-color: ${backgroundColor || get(theme, 'color.cardBgColor')};
      border-radius: 0;
      min-height: 100%;
      top: 0;
      width: 100%;
      margin-bottom: 0;
    `)}

    .empty-modal {
      ${({ isMobile, isPrivateView }) => (isMobile && !isPrivateView && `
        min-height: calc(100vh - ${({ theme }) => get(theme, 'spacing.default') * 3}px);
      `)}

      @media (min-width: ${({ theme }) => get(theme, 'breakpoint.md')}) {
        max-height: ${({ spacing }) => `calc(100vh - ${spacing}px)`};
        min-height: auto;
        overflow-y: auto;
      }
    }
  }

  &&.preview-notification-mobile {
    border-radius: 0;
    border: none;
    height: 100vh;
    top: 62px;
    width: auto;
  }

  &&.exit-modal {
    max-width: 380px;
    padding: ${({ theme }) => get(theme, 'spacing.default') * 2}px 30px;
  }

  &&.event-desktop-modal,
  &&.permissions-desktop-modal {
    max-height: calc(100vh - 100px);
    overflow-y: auto;
    top: 50px;
    width: 660px;
  }
      
  @media (min-width: ${({ theme }) => get(theme, 'breakpoint.md')}) {
    &&.filters-desktop-modal {
      max-height: calc(100vh - 100px);
      overflow-y: auto;
      top: 50px;
      width: 660px;

      [class*="MobileModalHeaderRebrand__HeaderText-sc"] {
        font-size: 24px;
        line-height: 26px;
      }
    }
  }
`;

const MobileModal = ({
  isMobile,
  isVisible,
  onClose,
  children,
  backgroundColor,
  className,
  hasCloseButton,
  closeOnMaskClick,
  mobileNotficationClass,
}) => (
  <ModalStyled
    isMobile={isMobile}
    isVisible={isVisible}
    hasCloseButton={hasCloseButton}
    onClose={onClose}
    backgroundColor={backgroundColor}
    className={className}
    closeOnMaskClick={closeOnMaskClick}
    spacing={340}
    mobileNotficationClass={mobileNotficationClass}
  >
    {children}
  </ModalStyled>
);

MobileModal.propTypes = {
  isMobile: PropTypes.bool,
  isVisible: PropTypes.bool,
  hasCloseButton: PropTypes.bool,
  closeOnMaskClick: PropTypes.bool,
  backgroundColor: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  onClose: PropTypes.func,
  mobileNotficationClass: PropTypes.string,
};

MobileModal.defaultProps = {
  isMobile: false,
  isVisible: false,
  hasCloseButton: false,
  closeOnMaskClick: true,
  backgroundColor: null,
  className: null,
  children: null,
  onClose: null,
  mobileNotficationClass: null,
};

export default MobileModal;
